export class RichTextRendererError extends Error {}
